<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_669)">
    <rect
      x="6.67972"
      y="6.76775"
      width="11.6406"
      height="12.4645"
      rx="2.125"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-miterlimit="10"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.38385 10.0919C9.38385 9.60867 9.7756 9.21692 10.2589 9.21692H14.7412C15.2244 9.21692 15.6162 9.60867 15.6162 10.0919C15.6162 10.5752 15.2244 10.9669 14.7412 10.9669H10.2589C9.7756 10.9669 9.38385 10.5752 9.38385 10.0919ZM9.38385 13C9.38385 12.5168 9.7756 12.125 10.2589 12.125H14.7412C15.2244 12.125 15.6162 12.5168 15.6162 13C15.6162 13.4832 15.2244 13.875 14.7412 13.875H10.2589C9.7756 13.875 9.38385 13.4832 9.38385 13ZM10.2589 15.0331C9.7756 15.0331 9.38385 15.4248 9.38385 15.9081C9.38385 16.3913 9.7756 16.7831 10.2589 16.7831H14.7412C15.2244 16.7831 15.6162 16.3913 15.6162 15.9081C15.6162 15.4248 15.2244 15.0331 14.7412 15.0331H10.2589Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_669">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
